var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-adorn",class:_vm.isReverse ? 'reverse' : '',style:('padding-right:'+_vm.space+'px')},[_c('img',{staticClass:"img",style:('width:' + _vm.width + 'px'),attrs:{"src":_vm.getImgUrl()}})])}
var staticRenderFns = []

export { render, staticRenderFns }